// @ts-check

import { Mappedin, getVenue } from "@mappedin/mappedin-js";
import { useEffect, useState } from "react";


/**
 * @typedef {import("@mappedin/mappedin-js").TGetVenueOptions} TGetVenueOptions
 * 
 */


/**
 * @param {TGetVenueOptions | null} options
 */
export default function useVenue(options) {

  
  /** 
   * @type {[Mappedin | undefined, Function]}
   */
  const [venue, setVenue] = useState();


  useEffect(() => {

    let ignore = false;

    async function fetchData() {

      if (!options) {
        return;
      }

      try {
        // console.log('+++++++++ Get Venue options ===> ', options);
        const data = await getVenue(options);
        if (!ignore) {
          setVenue(data);
        }
      } catch (e) {
        setVenue(undefined);
      }

    }

    fetchData();

    return () => {
      ignore = true;
    };

  }, [options]);


  return venue;
}
